import maNavbarCategorySpecific from '@/components/navbarCategoriesSpecific'
import maForm from '@/components/mobilierForm'
import maAddDamages from '@/components/button-blue'
import maNotificationsTop from '@/components/notifications-top'
import maInputFile from '@/components/input/modules/fileImg'
import maModal from '@/components/modal'
import maInputTxt from '@/components/input/modules/text'
import maDatePicker from '@/components/datePicker'
import moment from 'moment'
import maEventBus from '@/components/eventbus/index.js'
import maNavbarStepper from '@/components/navbarStepper'
import debounce from '@/utils/debounce'
import { mapState, mapMutations, mapActions } from 'vuex'
import { apiGetForm } from '@/modules/Damage/services/menus'
import {
  apiPatchDamage,
  apiPostDamageUptec
} from '@/modules/Damage/services/damages'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_FORMS,
  WARRANTY_CLEAR_REPORT,
  WARRANTY_UPDATE_REPORT,
  WARRANTY_UPDATE_CATEGORIES_QTY,
  WARRANTY_UPDATE_CATEGORIES_MOBILIER,
  WARRANTY_CLEAR_FORMS,
  WARRANTY_UPDATE_DAMAGED_ITEM,
  WARRANTY_UPDATE_LITERALS_MOBILIER,
  WARRANTY_UPDATE_TEXT_SEARCH_MOBILIER,
  WARRANTY_UPDATE_CATEG_FINAL_LEVEL,
  WARRANTY_UPDATE_LAST_SELECTED_PROPERTIES,
  WARRANTY_GET_SINISTER,
  WARRANTY_GET_FINAL_LEVEL,
  WARRANTY_UPDATE_DAMAGED_ITEM_KEY,
  WARRANTY_UPDATE_OBJ_UPTEC
} from '@/store/types'
import {
  FEATURE,
  CPI,
  FORM_INPUTS_MOBILIER,
  FORM_UPTEC_FEATURE,
  FORM_UPTEC_CPI
} from '@/constants'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { prepareErrorForSentry } from '@/utils/errorHandling'

export default {
  name: 'damageMobilierCategory2',

  mixins: [flowMixin],

  data: function () {
    return {
      formData: [],
      titleCategory: '',
      damage: {
        asset_damages: 0
      },
      activeInput: '',
      activeInputValue: '',
      addDamageBtnIsHidden: false,
      levels: {},
      formTemplate: null,
      formKey: 0,
      warrantySubtypeId: null,
      imgListEnsemble: [],
      imgListPres: [],
      error: false,
      errorMsg: '',
      formType: '',
      poductIdGroup: null,
      inputValPrice: null,
      inputValDate: '',
      errorDate: false,
      errorPrice: false,
      loading: false,
      isDisabledBtn: null
    }
  },

  components: {
    maNavbarCategorySpecific,
    maForm,
    maAddDamages,
    maNotificationsTop,
    maInputFile,
    maModal,
    maInputTxt,
    maDatePicker,
    maNavbarStepper
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterId: 'sinisterId',
      stateWarrantyForms: 'forms',
      stateWarrantyCategoriesMobilier: 'categoriesMobilier',
      stateWarrantyCategoriesQty: 'categoriesQty',
      stateWarrantyDamagedItem: 'damagedItem',
      stateWarrantySecondaryId: 'secondaryId',
      stateWarrantyAddress: 'address',
      stateWarrantyZipCode: 'zipCode',
      stateWarrantyCoordinates: 'coordinates',
      stateWarrantyMoreThanTwoYears: 'moreThanTwoYears',
      stateWarrantyPropertyType: 'propertyType',
      stateWarrantyResidentType: 'residentType',
      stateWarrantyaddress: 'address',
      stateWarrantyLiteralsMobilier: 'literalsMobilier',
      stateWarrantyCategoryFinalLevel: 'categoryFinalLevel',
      stateWarrantyKeysMobilier: 'keysMobilier',
      stateWarrantySubtypeId: 'subtypeId',
      stateWarrantyDamagedItemKey: 'damagedItemKey'
    }),
    getBtnType() {
      return this.loading ? 'spinnerBtn' : 'functionalBtn'
    },
    showDateWithCorrectForm() {
      let date = moment(this.inputValDate, 'YYYY-MM-DD')
      let newFormat = date.format('DD-MM-YYYY')
      return newFormat
    }
  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyClearReport: WARRANTY_CLEAR_REPORT,
      mutWarrantyClearForms: WARRANTY_CLEAR_FORMS,
      mutWarrantyUpdateReport: WARRANTY_UPDATE_REPORT,
      mutWarrantyUpdateCategoriesQty: WARRANTY_UPDATE_CATEGORIES_QTY,
      mutWarrantyUpdateCategoriesMobilier: WARRANTY_UPDATE_CATEGORIES_MOBILIER,
      mutWarrantyUpdateDamagedItem: WARRANTY_UPDATE_DAMAGED_ITEM,
      mutWarrantyUpdateLiteralsMobilier: WARRANTY_UPDATE_LITERALS_MOBILIER,
      mutWarrantyUpdateTextSearchMobilier: WARRANTY_UPDATE_TEXT_SEARCH_MOBILIER,
      mutWarrantyUpdateCategFinalLevel: WARRANTY_UPDATE_CATEG_FINAL_LEVEL,
      mutWarrantyUpdateLastSelectedProperties:
        WARRANTY_UPDATE_LAST_SELECTED_PROPERTIES,
      actWarrantyGetFinalLevel: WARRANTY_GET_FINAL_LEVEL,
      mutWarrantyUpdateDamagedItemKey: WARRANTY_UPDATE_DAMAGED_ITEM_KEY,
      mutWarrantyUpdateObjUptec: WARRANTY_UPDATE_OBJ_UPTEC
    }),
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetForms: WARRANTY_GET_FORMS,
      actWarrantyGetSinister: WARRANTY_GET_SINISTER
    }),

    /**
     * Checks if there is inputValDate and sets the errorDate prop to true of false
     */
    checkInputDateValue() {
      if (this.inputValDate) {
        this.errorDate = false
      } else {
        this.errorDate = true
      }
    },

    /**
     * Checks if the format of the price is correct and if not it sets it to the correct format
     */
    checkInputPriceFormat(valuePrice) {
      const priceIntegr = parseInt(valuePrice)
      if (isNaN(priceIntegr)) {
        this.errorPrice = true
      } else {
        this.errorPrice = false
        this.inputValPrice = Math.trunc(priceIntegr)
      }
    },

    /**
     * Cheks if there is input date value and if there is no errorDate of errorPrice it will open the confirmation modal
     */
    handleOpenModal() {
      this.checkInputDateValue()
      if (!this.errorDate && !this.errorPrice) {
        this.$refs.modalConfirmation.showModal = true
      }
    },

    /**
     * Closes the confrimation modal
     */
    closeModaConfirmation() {
      this.$refs.modalConfirmation.showModal = false
    },

    /**
     * Sets the inputValDate with the value of the data picker only that formated
     */
    handleChangeInputDate(value) {
      this.inputValDate = moment(value).format('YYYY-MM-DD')
    },

    /**
     * Removes the last literal and the last category added in the previous view and goes t the previous view
     */
    handleClickPrevPage() {
      const lastLiteral =
        Object.values(this.stateWarrantyLiteralsMobilier).length - 1
      const keyLastLiteral = Object.keys(this.stateWarrantyLiteralsMobilier)[lastLiteral]

      // remove last caegory
      delete this.stateWarrantyCategoriesMobilier[this.stateWarrantyDamagedItemKey]

      // remove last literal
      delete this.stateWarrantyLiteralsMobilier[keyLastLiteral]

      // remove last caegory
      if (this.stateWarrantyCategoryFinalLevel === true) {
        this.mutWarrantyUpdateCategFinalLevel(false)
      }
      this.goBack()
    },

    /**
     * When a category of the first level list of a category is clicked it updates the damaged key, the last selected properties, the categories mobilier object, the literals and checks if this category is final level category or not, and goes to next route
     */
    handleClickCategory(key, value, id, literal) {
      const reportObj = this.stateWarrantyCategoriesMobilier
      reportObj[key] = value
      let category = 'cat2'
      this.mutWarrantyUpdateLastSelectedProperties({ key, category })
      this.mutWarrantyUpdateCategoriesMobilier(reportObj)
      category = 'cat3'
      this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
      this.levels[`level3`] = id
      this.mutWarrantyUpdateCategFinalLevel(true)
      this.mutWarrantyUpdateDamagedItemKey(key)
      const warrantyId = this.getWarrantyId
      const report = reportObj
      this.actWarrantyGetForms({ report, warrantyId }).then((resp) => {
        if (resp.formsUpdated) {
          this.goToNextRoute()
        }
      })
    },

    goToNextRoute() {
      const damageMobilierCategory3ViewName = 'damageMobilierCategory3'
      const propertyType = this.getPropertyType
      const damageType = this.getDamageType
      this.goToView(damageMobilierCategory3ViewName, {
        propertyType,
        damageType
      })
    },

    /**
     * Filters the image arrays, deletes the imgSrc key
     */
    filterImageSrc() {
      /* this.imgListEnsemble.forEach((image) => {
        delete image.imgSrc
      }) */
      this.imgListPres.forEach((image) => {
        delete image.imgSrc
      })
    },

    async handleEnableButton() {
      let imgList = []
      imgList = [...imgList, ...this.imgListEnsemble, ...this.imgListPres]
      const imagesValidated = await this.checkImages(imgList)
      if (imagesValidated) {
        this.isDisabledBtn = false
      } else {
        this.isDisabledBtn = true
      }
    },

    checkImages(imgList) {
      if (!this.addDamagesHasImages) return true

      if (emptyImgList[0] === '0' || emptyImgList[0] === '1') {
        return true
      } else {
        const imageTypes = [, /* 'inputImgEnsemble' */ 'inputImgPres']
        const imageListTypes = [
          ...new Set(imgList.map((image) => image.imageType))
        ]

        return imageTypes.every(
          (imageType) => imageListTypes.indexOf(imageType) > -1
        )
      }
    },

    async handleAddDamages() {
      this.loading = true
      let imgList = []
      this.filterImageSrc()
      this.getSubwarrantyId()
      imgList = [
        ...imgList /* , ...this.imgListEnsemble */,
        ...this.imgListPres
      ].filter(img => img != null)

      const imagesValidated = await this.checkImages(imgList)
      if (imagesValidated) {
        this.updateForm().then(() => {
          this.damage['asset_damages'] = this.formData.form.asset_damages
          let damageBody = {
            sinister_id: this.getSinisterId,
            event_id: this.stateWarrantySecondaryId,
            category: this.getWarrantyId,
            subcategory: this.stateWarrantySubtypeId || this.warrantySubtypeId,
            form_info: {
              CAPACITE: this.damage.CAPACITE,
              REMPLISSAGE: this.damage.REMPLISSAGE,
              asset_damages: this.damage.asset_damages,
            },
            images: imgList
          }

          const postBody = {
            lat: this.stateWarrantyCoordinates.lat,
            lon: this.stateWarrantyCoordinates.lng,
            zip_code: this.stateWarrantyZipCode,
            real_estate: this.stateWarrantyPropertyType,
            declarant: this.stateWarrantyResidentType,
            more_than_two_years: this.stateWarrantyMoreThanTwoYears,
            address: this.stateWarrantyAddress
          }

          damageBody = {
            ...damageBody,
            ...postBody
          }

          // 400 campos faltan, 500 generico
          apiPatchDamage(damageBody)
            .then(() => {
              this.mutWarrantyClearForms()
              this.mutWarrantyClearReport()
              const damagesViewViewName = 'damages-view'
              this.goToView(damagesViewViewName)
            })
            .catch((error) => {
              this.loading = false
              this.error = true
              this.errorMsg = this.$t(
                `notifications.error.${error.response.status}.title`
              )

              const context = {
                component: 'damageMobilierCategory2',
                method: 'handleAddDamages',
                route: this.$route.path
              }

              const tags = prepareErrorForSentry(error, context)

              this.sendSentryError(
                `Error adding damage report: ${error.message || 'Unknown error'}`,
                error.response && error.response.status >= 500 ? 'error' : 'warning',
                tags,
                this.getWarrantyId,
                'handleAddDamages'
              )

              setTimeout(() => {
                this.error = false
              }, 2000)
            })
        })
      } else {
        this.loading = false
        window.scrollTo(0, 0)
        this.throwNotification(
          this.$t('claim.details.errorImages'),
          this.$t('claim.details.errorImages'),
          'KO'
        )
      }
    },

    /**
     * Damage is updated locally on input change.
     */
    handleFormChange: function (event) {
      if (event.inpTextNumbers) {
        const inputValParsed = event.inputVal.replace(',', '.')
        this.damage[event.inputId] = inputValParsed
      } else {
        this.damage[event.inputId] = event.inputVal
      }
      this.handleEnableButton()
    },

    /**
     * Debounced function (Important. Just first input event is catched). Form has to be updated always because rep_type_code changes depending on input value combination.
     */
    handleNestedComponents: debounce(function (event) {
      this.activeInputValue = event.inputVal
      this.updateForm()
    }, 250),

    updateForm: function () {
      const report = Object.assign({}, this.damage)
      const formInputs = document.querySelectorAll('.warranty__content input')

      delete report['asset_damages']

      formInputs.forEach(function (el) {
        el.disabled = true
      })
      return apiGetForm(report, this.getWarrantyId)
        .then((data) => {
          this.formData = null
          this.$nextTick(() => {
            this.formData = data
            Object.keys(this.stateWarrantyCategoriesMobilier).forEach((key) => {
              this.formData.form.regions[0].inputs =
                this.formData.form.regions[0].inputs.filter((input) => {
                  return input.name !== key
                })
            })
            this.formData.form.regions[0].inputs =
              this.formData.form.regions[0].inputs.filter((input) => {
                return input.type !== 'hidden'
              })
            this.setDefaultValuesForm()
            this.$nextTick(() => {
              this.handleUpdateForm()
            })
          })
        })
        .catch((error) => {
          const context = {
            component: 'damageMobilierCategory2',
            method: 'updateForm',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error getting warranty form: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            tags,
            this.getWarrantyId,
            'updateForm'
          )
        })
        .finally(() => {
          formInputs.forEach(function (el) {
            el.disabled = false
          })
        })
    },

    /**
     * Sets the focus/blur for the active input
     */
    handleUpdateForm: function () {
      if (this.activeInput !== '') {
        const activeInputType = this.activeInput.getAttribute('type')
        const activeInputName = this.activeInput.getAttribute('name')
        const activeInputVal = this.activeInputValue
        // REFACTOR MOVER A FORM
        if (
          activeInputType === 'checkbox' &&
          this.activeInput.hasAttribute('isSelect')
        ) {
          document.querySelector('input[name=' + activeInputName + ']').focus()
          document.querySelector('input[name=' + activeInputName + ']').blur()
        } else if (activeInputType === 'text') {
          document.querySelector('input[name=' + activeInputName + ']').focus()
        } else {
          const el = document.querySelector(
            'input[value="' + activeInputVal + '"]'
          )
          if (el) el.focus()
        }
      }
    },

    /**
     * Sets the defauld values for each form when is updated - the input.selected values that come from the forms api
     */
    setDefaultValuesForm: function () {
      this.damage.asset_damages = this.formData.form.asset_damages || ''
      this.formData.form.regions.forEach((region) => {
        region.inputs.forEach((input) => {
          if (input.selectedValue) {
            this.damage[input.name] = input.selectedValue
          }
        })
      })
    },

    /**
     * Sets the defauld values for each form when the view is printed - the input.selected values that come from the forms api
     */
    setDefaultValues: function () {
      this.damage = {}
      this.damage.asset_damages = this.formData.form.asset_damages || ''
      this.damage = Object.assign({}, this.stateWarrantyCategoriesMobilier)
      this.formData.form.regions.forEach((region) => {
        region.inputs.forEach((input) => {
          if (input.selectedValue) {
            this.damage[input.name] = input.selectedValue
          }
        })
      })
    },

    /**
     * Adds levels to the levels object
     */
    addLevels(form, key) {
      form.forEach((input) => {
        if (
          this.stateWarrantyCategoriesQty === 2 &&
          input.name === key &&
          input.name !== 'ASSETS'
        ) {
          if (!this.levels.level1) this.levels['level1'] = input.id
        } else if (
          this.stateWarrantyCategoriesQty === 3 &&
          input.name === key
        ) {
          if (!this.levels.level1) this.levels['level1'] = input.id
          if (!this.levels.level2 && this.levels.level1.id !== input.id) {
            this.levels['level2'] = input.id
          }
          if (
            !this.levels.level3 &&
            this.levels.level1.id !== input.id &&
            this.levels.level2.id !== input.id
          ) {
            this.levels['level2'] = input.id
          }
        }
      })
    },

    getNewForm() {
      this.mutWarrantyClearForms()
      let report = Object.assign(this.stateWarrantyCategoriesMobilier, {})
      delete report[this.stateWarrantyKeysMobilier.cat2]
      const warrantyId = this.getWarrantyId
      this.actWarrantyGetForms({ report, warrantyId }).then((res) => {
        if (res.formsUpdated) {
          this.formTemplate = Object.assign(this.stateWarrantyForms[0], {})
          this.filterForm()
        }
      })
    },

    /**
     * Updates the state report, calls action actWarrantyGetForms to get the froms and sets the data for the forms, sets the default value inputs for the form
     */
    getForm() {
      if (this.stateWarrantyKeysMobilier.cat1) {
        this.getNewForm()
      } else {
        this.formTemplate = Object.assign(this.stateWarrantyForms[0], {})
        this.filterForm()
      }
      this.handleEnableButton()
    },

    /**
     * Filters the form of hidden inputs and categories selected in previous views
     */
    filterForm() {
      // if the form has more categories remove the ones selected before and print the first input
      if (this.stateWarrantyCategoryFinalLevel === false) {
        // remove categories selected before
        Object.keys(this.stateWarrantyCategoriesMobilier).forEach((key) => {
          // add levels
          this.addLevels(this.formTemplate.form.regions[0].inputs, key)

          this.formTemplate.form.regions[0].inputs =
            this.formTemplate.form.regions[0].inputs.filter((input) => {
              return input.name !== key
            })
        })
        // remove hidden inputs
        this.formTemplate.form.regions[0].inputs =
          this.formTemplate.form.regions[0].inputs.filter((input) => {
            return input.type !== 'hidden'
          })
        this.formData = this.formTemplate.form.regions[0].inputs[0]
      } else {
        this.setFormType()
        Object.keys(this.stateWarrantyCategoriesMobilier).forEach((key) => {
          this.formTemplate.form.regions[0].inputs =
            this.formTemplate.form.regions[0].inputs.filter((input) => {
              return input.name !== key
            })
        })
        this.formTemplate.form.regions[0].inputs =
          this.formTemplate.form.regions[0].inputs.filter((input) => {
            return input.type !== 'hidden'
          })
        this.formData = this.formTemplate

        const sinisterId = this.getSinisterId
        if (!this.stateWarrantySinisterId) {
          this.actWarrantyGetSinister(sinisterId)
        }
        this.setDefaultValues()
        this.setWatchers()
      }
    },
    setWatchers: function () {
      let vm = this
      vm.$watch('getWarrantyId', function () {
        this.updateForm()
        this.clearForm()
      })
    },

    /**
     * Sets title category
     */
    setTitleCategory() {
      const lastLiteral =
        Object.values(this.stateWarrantyLiteralsMobilier).length - 1
      this.titleCategory = Object.values(this.stateWarrantyLiteralsMobilier)[
        lastLiteral
      ]
    },

    /**
     * Sets the focus when an input is modified
     */
    handleInputFocus: function () {
      const focusedInput = document.querySelector('input:focus')
      if (document.querySelector('input:focus') !== null) {
        this.activeInput = focusedInput
      }
    },

    /**
     * Gets the warranty id from local storage if it doesen't exist
     */
    getSubwarrantyId() {
      if (!this.stateWarrantySubtypeId) {
        this.warrantySubtypeId = localStorage.getItem('warranty_subtype_id')
      }
    },

    /**
     * Pushes the image in the imgListEnsemble array
     */
    handleImgChangeEnsemble(event) {
      const dataImg = event.fileData ? event.fileData : event
      this.imgListEnsemble.push(dataImg)
      this.handleEnableButton()
    },

    /**
     * Pushes the image in the imgListPres array
     */
    handleImgChangePres(event) {
      const dataImg = event.fileData ? event.fileData : event
      this.imgListPres.push(dataImg)
      this.handleEnableButton()
    },

    /**
     * Gets the target uptec option(subcategory) that was last selected, stateWarrantyCategoriesMobilier has all the selected categories selected from a product, and damagedItemKey is the key of the last selected category
     */
    getTargetUptecItem() {
      if (this.stateWarrantyCategoriesMobilier) {
        return this.stateWarrantyCategoriesMobilier[
          this.stateWarrantyDamagedItemKey
        ].toUpperCase()
      }
    },

    /**
     * Sets the form type, if the option is uptec damage and its type is cpi, it will get the targetUptecItem which is the last selected category to get the correct product id for this option, else if it's an uptec damage and the type is feature it will only set the form type and get the product id as there will be only one result for it, else it's the formInputsMobilier, the general form with its corresponding inputs
     */
    setFormType() {
      const formInput = this.formTemplate.form.regions[0].inputs.find(
        (input) => input.name === this.stateWarrantyDamagedItemKey
      )
      const formInputOption = formInput.options.find(
        (option) => option.key.toUpperCase() === this.getTargetUptecItem()
      )

      if (formInputOption.is_upptec_damage === false) {
        this.formType = FORM_INPUTS_MOBILIER
      } else {
        if (formInputOption.upptec_damage_type === FEATURE) {
          this.formType = FORM_UPTEC_FEATURE
          this.poductIdGroup = formInputOption.upptec_productIdGroup
        } else if (formInputOption.upptec_damage_type === CPI) {
          this.formType = FORM_UPTEC_CPI
          this.poductIdGroup = formInputOption.upptec_product_group_id
        }
      }
    },

    getUptecObj() {
      let key = 'titleCat'
      let value = this.titleCategory
      this.mutWarrantyUpdateObjUptec({ key, value })
      key = 'titleCat'
      value = this.titleCategory
      this.mutWarrantyUpdateObjUptec({ key, value })
      key = 'cat2'
      value = this.stateWarrantyLiteralsMobilier.cat2
      this.mutWarrantyUpdateObjUptec({ key, value })
      key = 'cat1'
      value = this.stateWarrantyLiteralsMobilier.cat1
      this.mutWarrantyUpdateObjUptec({ key, value })
    },

    /**
     * Adds the damage for the cpi uptec mobilier
     */
    async handleAddDamagesCpi() {
      this.loading = true
      let imgList = []
      this.getUptecObj()
      this.filterImageSrc()
      this.getSubwarrantyId()
      imgList = [
        ...imgList /* , ...this.imgListEnsemble */,
        ...this.imgListPres
      ]

      const imagesValidated = await this.checkImages(imgList)
      if (imagesValidated) {
        if (this.poductIdGroup && this.inputValDate && this.inputValPrice) {
          const objDamage = {
            sinister_id: this.getSinisterId,
            product_group_id: this.poductIdGroup,
            upptec_damage_type: 'CPI',
            date_of_purchase: this.inputValDate,
            purchase_price: this.inputValPrice,
            images: imgList
          }
          this.$refs.modalConfirmation.showModal = false

          apiPostDamageUptec(objDamage)
            .then((res) => {
              let key = 'date'
              let value = res.date_of_purchase
              this.mutWarrantyUpdateObjUptec({ key, value })
              key = 'price'
              value = res.purchase_price.amount
              this.mutWarrantyUpdateObjUptec({ key, value })
              const depreciation = res.calculation_details.depreciation * 100
              key = 'depreciation'
              value = Math.trunc(depreciation)
              this.mutWarrantyUpdateObjUptec({ key, value })
              key = 'indemnisation'
              value = res.calculation_details.compensation.amount
              this.mutWarrantyUpdateObjUptec({ key, value })
              key = 'totalPayment'
              value = res.calculation_details.current_market_price.amount
              this.mutWarrantyUpdateObjUptec({ key, value })
              key = 'images'
              value = res.images
              this.mutWarrantyUpdateObjUptec({ key, value })

              this.mutWarrantyClearForms()
              this.mutWarrantyClearReport()
              const damageResultUptecViewName = 'damage-result-uptec'
              this.goToView(damageResultUptecViewName)
            })
            .catch((error) => {
              this.loading = false
              this.error = true
              this.errorMsg = this.$t(
                `notifications.error.${error.response.status}.title`
              )

              const context = {
                component: 'damageMobilierCategory2',
                method: 'handleAddDamagesCpi',
                route: this.$route.path
              }

              const tags = prepareErrorForSentry(error, context)

              this.sendSentryError(
                `Error adding CPI damage: ${error.message || 'Unknown error'}`,
                error.response && error.response.status >= 500 ? 'error' : 'warning',
                tags,
                this.getWarrantyId,
                'handleAddDamagesCpi'
              )

              setTimeout(() => {
                this.error = false
              }, 2000)
            })
        } else {
          this.loading = false
          this.error = true
          this.errorMsg = this.$t(`notifications.error.${400}.title`)
          setTimeout(() => {
            this.error = false
          }, 2000)
        }
      } else {
        this.loading = false
        this.$refs.modalConfirmation.showModal = false
        window.scrollTo(0, 0)
        this.throwNotification(
          this.$t('claim.details.errorImages'),
          this.$t('claim.details.errorImages'),
          'KO'
        )
      }
    }
  },

  watch: {
    inputValPrice(value) {
      if (value.length >= 1) this.checkInputPriceFormat(value)
    }
  },

  /**
   * Sets the title category and gets form
   */
  mounted() {
    this.mutWarrantyUpdateCategoriesQty(2)
    this.setTitleCategory()
    this.getForm()

    maEventBus.$on('inputWarranty:focus', ($event) =>
      this.handleInputFocus($event)
    )
  }
}
